import { DataStore, Predicates, SortDirection } from '@aws-amplify/datastore';
import * as alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DeleteButton from '../../../../../components/common/buttons/DeleteButton';
import EditButton from '../../../../../components/common/buttons/EditButton';
import LeftSideBar from '../../../../../components/common/hr/leftnav.component';
import TopNav from '../../../../../components/common/hr/topnav.component';
import { DataTableCustomStyles } from '../../../../../components/helper/dataTable.config';
import { ValidateHRRole } from '../../../../../components/helper/validateRole';
import { Roles } from '../../../../../models';
import HRLogin from '../../../../../setup/auth/hr.component';
import { graphQLGetAllData, graphQLFindRecordById } from '../../../../../components/helper/graphQLFunctions';
import * as mutations from '../../../../../graphql/mutations';
import * as queries from '../../../../../graphql/queries';
import { API, graphqlOperation } from 'aws-amplify';

export default function HrRole() {

    //Validate User Logged In
    const [isAuthenticated, userHasAuthenticated] = useState(true);
    let navigateTo = useNavigate();

    //list
    const [roles, SetRoleList] = useState([]);
    const [rolesFilterList, SetRolesFilterList] = useState([]);


    //onclick edit
    const handleEditClick = (e, id) => {
        e.preventDefault();
        navigateTo('/hr/settings/createrole/' + id);
    };

    //onclick delete
    const handleDeleteClick = async (e, id) => {
        e.preventDefault();
        //const objDeleteRole = await DataStore.query(Roles, id);
        const objDeleteRole = await graphQLFindRecordById('getRoles', id);
        alertify.confirm('Confirmation', 'Do you want to delete this Role?', async function () {
            //Delete Existing InterpreterRequest for this language
            //DataStore.delete(Roles, (c) => c.id("eq", id))
            //Delete language
            // DataStore.delete(objDeleteRole);

            await API.graphql({
                query: mutations.deleteRoles,
                variables: {
                    input: {
                        id: objDeleteRole.id,
                        _version: objDeleteRole._version,
                    }
                }
            });
            BindList();
            toast.success("Deleted");
        }
            , function () { });

    };

    //*Table Column Name
    const DataTableColumns = [
        {
            name: 'Role',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Level',
            selector: row => row.sortOrder,
            sortable: true,
            center: true
        },
        {
            name: 'Action',
            cell: (row) => (
                <>
                    <div className="flex gap-8">
                        <Link onClick={(e) => handleEditClick(e, row.id)} ><EditButton /></Link>
                        <Link onClick={(e) => handleDeleteClick(e, row.id)} ><DeleteButton /></Link>
                    </div>
                </>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            center: true
        }
    ];

    async function onLoad() {
        try {
            if (!ValidateHRRole()) { userHasAuthenticated(false); }
        } catch (e) {
            userHasAuthenticated(false);
        }
    }

    //Search Roles
    const searchRoles = (searchedText) => {
        if (searchedText.length > 1) {
            let data = [...rolesFilterList]
            let filteredData = data.filter(e =>
                e.name.toLowerCase().includes(searchedText.toLowerCase())
            )
            SetRoleList(filteredData)
        } else {
            let data = [...rolesFilterList]
            SetRoleList(data)
        }
    }

    //Bind List
    async function BindList() {
        // var roleResponses = await DataStore.query(Roles, Predicates.ALL, {
        //     sort: s => s.sortOrder(SortDirection.ASCENDING)
        // });
        var roleResponses = await graphQLGetAllData('listRoles');
        roleResponses = roleResponses.sort((a, b) => a.sortOrder - b.sortOrder);
        SetRoleList(roleResponses)
        SetRolesFilterList(roleResponses)
    }

    useEffect(() => {
        onLoad();
        BindList();
    }, []);

    return (
        isAuthenticated ? (

            <div>
                <div className="pt-16">
                    <TopNav />
                    <LeftSideBar />
                    <div className="dashboard-main-wrapper pl-20 pr-4 mt-3">
                        <div className="flex flex-1 flex-wrap p-5 pb-4 px-0 top-action-wrapper">
                            <div className="md:flex xs:w-full sm:w-full md:w-auto flex-row align-center">
                                <div className="md:flex block md:col-span-2 mb-4">
                                </div>
                                <div className="md:flex block mb-4">
                                    <h2 className="page-title">Roles</h2>
                                </div>
                            </div>

                            <div className="md:flex flex-1 flex-row xs:w-full sm:w-full md:w-auto align-center justify-end md:ml-auto gap-3 right-side">
                                <div className="relative">
                                    <input onChange={(e) => searchRoles(e.target.value)} type="text" id="required-search" className="rounded-md border border-[#D0D5DD] focus:border-transparent w-full py-2.5 pl-3 bg-white text-gray-700 placeholder-gray-500 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 dark:bg-[#403E3C] dark:text-[#FFFFFF] dark:border-[#403E3C]" placeholder="Search..." />
                                </div>
                                <div className="md:flex block mb-4 gap-4">
                                    <Link to="/hr/settings" className="flex py-2 px-5 bg-[#FFF] hover:bg-blue-0 focus:ring-blue-500 focus:ring-offset-blue-200 text-black transition ease-in duration-200 text-[14px] text-center font-medium drop-shadow shadow-md focus:outline-none focus:ring-1 focus:ring-offset-1 leading-6  justify-center rounded-md border-1 border-[#1570EF] dark:bg-[#4A5056]  dark:border-[#333231] dark:text-[#FFFFFF]">
                                        Back
                                    </Link>
                                    <Link to="/hr/settings/createrole" className="flex py-2 px-5 bg-btn-blue hover:bg-blue-0 focus:ring-blue-500 focus:ring-offset-blue-200 text-white transition ease-in duration-200 text-[14px] text-center font-medium drop-shadow shadow-md focus:outline-none focus:ring-1 focus:ring-offset-1 leading-6  justify-center rounded-md border-1 border-[#1570EF]">
                                        Create
                                    </Link>
                                </div>

                            </div>
                        </div>
                        <div>
                            <div className={"block w-full pt-5"}>
                                {
                                    <DataTable
                                        columns={DataTableColumns}
                                        data={roles}
                                        customStyles={DataTableCustomStyles}
                                        pagination
                                        highlightOnHover
                                        paginationPerPage={10}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        ) : (
            <HRLogin sessionExpired={1} />
        )

    )
}



